import React from 'react';
import ME from '../images/me.jpg';

export default function About() {
    const style = {
        paragraph: {
            fontSize: "18px"
        },
        aboutdiv: {
            margin: "0 auto",
            width: "75%",
            border: "1px solid black",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "20px"
        },
        overall: {
            backgroundColor: "#0b486b",
            height: "auto",
            minHeight: "80vh",
            padding: "50px 0"
        },
        link: {
            textDecoration: "none"
        },
        title: {
            fontSize: "32px",
            margin: "4px",
            textAlign: "center"
        },
        me: {
            width: "150px",
            float: "left",
            margin: "18px 10px 0 0"
        }
    }
    return (
        <div style={style.overall}>
            <div style={style.aboutdiv}>
            <h2 style={style.title}>About Me</h2>
                <img src={ME} alt="Picture of me" style={style.me}/>
                <p style={style.paragraph}>
                    Hello. My name is Michael. I am a software engineer focused on developing web and mobile apps. The languages I program in are ReactJS, Ruby on Rails, Javascript, HTML, and CSS.
                </p>
                <p style={style.paragraph}>
                    I have a computer science degree from Lehigh University. After working as C++
                    developer for a few years, I served in the United States Army as a field artillery officer. After four years of active duty service (including a 16-month deployment to Iraq), I went to Western Kentucky University to study Photojournalism.
                </p>
                <p style={style.paragraph}>
                    From there I worked as a photographer and photo editor for the New York Daily News, ABC News, Newsweek and various other publications. I eventually shifted into the fashion world working for such clients as WWD Japan, Harper's Bazaar Chile, Chaumet amongst others.
                </p>
                <p style={style.paragraph}>
                    After living in Spain for many years, I decided to return to New York City and return to programming. I studied software engineering at General Assembly to speed up the process.
               </p>
                <p style={style.paragraph}>
                    In my free time I enjoy travelling around the world. One of my goals in life is to visit every sovereign country in the world. The next place I want to visit is Madagascar.
                </p>
                <p style={style.paragraph}>
                    <a href="http://mikeip.com/resume/MichaelIpResume.pdf" style={style.link}>View my CV (pdf)</a>
                </p>
            </div>

        </div>
    )
}